import { IconProps } from './types';

export default function Video({ className, strokeWidth }: IconProps) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            role="img"
            className={className}
            strokeWidth={strokeWidth}
        >
            <path
                d="M20 6L12 13.3333L4 6"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4 6H20V17.3333C20 17.5101 19.9298 17.6797 19.8047 17.8047C19.6797 17.9298 19.5101 18 19.3333 18H4.66667C4.48986 18 4.32029 17.9298 4.19526 17.8047C4.07024 17.6797 4 17.5101 4 17.3333V6Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.5417 12L4.20834 17.8083"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.7917 17.8083L13.4583 12"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
